<template>
  <div>
    <div class="container">
       <el-row>

         <el-col :span="16" :offset="4">
           <el-card id="cardBox">
             <h2 class="tit">{{newsData.noticeTitle}}</h2>
             <div class="detailsInfoMod">
               <div class="time">
                 <span>{{newsData.createTime}}</span>
               </div>
               <div class="iconmod">
               </div>
             </div>
             <div class="detailsCon" id="detailsCon" v-html="newsData.noticeContent">
             </div>


           </el-card>
         </el-col>
       </el-row>



    </div>
  </div>

</template>

<script>
// 动画 animate.css
// import animate from "animate.css";
import {getNoticeById} from "@/api/kms/notice";
export default {

  name: "infolistItem",
  data(){
    return {
      newsData:{},
      backUrl:'#/news',

    }
  },
  created() {
    this.getNew()
  },
  methods:{
    //获取新闻内容
    getNew(id){
      if(this.$route.query.back){
        this.backUrl=this.$route.query.back
      }

      getNoticeById(id?id:this.$route.query.id).then(response=>{
        this.newsData= response.data.data
      })
    },


  }
}
</script>

<style scoped>

@media (min-width: 768px) {


  #detailsCon>>>iframe{
    width: 100%;
    height: 320px;
  }
}

.container {
  width: 1440px;
}

@media (min-width: 993px) {


  #detailsCon>>>iframe{
    width: 100%;
    height: 360px;
  }
}
@media (min-width: 1200px){
.container {
  width: 1440px;
}
  #detailsCon>>>iframe{
    width: 100%;
    height: 400px;
  }
  #detailsCon>>>p{
    line-height: 35px;
  }
}
@media (min-width: 1799px) {
  .container {
    width: 1440px;
  }
  #detailsCon>>>iframe{
    width: 100%;
    height: 400px;
  }
  #detailsCon>>>p{
    line-height: 35px;
  }

}







.container {

  padding-right: 15px;
  padding-left: 15px;
  margin-top: 5%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 15%;
}
.detailsInfoMod {
  padding-bottom: 38px;
  margin-bottom: 38px;
  border-bottom: 3px solid #e6e6e6;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.detailsInfoMod .time {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.detailsInfoMod .iconmod {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.detailsInfoMod .time span {
  color: #ccc;
  font-size: 20px;
  line-height: 1;
}
  .tit {
  font-weight: normal;
  font-size: 30px;
  color: #333333;
  margin: 15px 0 30px;
  line-height: 1.4;
}
.detailsCon{
  min-height: 800px;
  white-space: pre-wrap;
}
.detailsCon p {
  font-size: 18px;
  line-height: 2;
  margin-bottom: 20px;
}
#detailsCon>>>img {
  max-width: 100%;
  height: auto !important;
  display: block;
}
.detailsGuideMod {
  margin-top: 100px;
}
.detailsGuideMod .line {
  margin-bottom: 40px;
  width: 100%;
  height: 1px;
  background: #e6e6e6;
}
.detailsGuideMod .info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.detailsGuideMod .info .btn {
  width: 198px;
  height: 60px;
  font-size: 18px;
  color: grey;
  border: 1px solid #e6e6e6;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.detailsGuideMod .info .returns .icon {
  margin-bottom: 6px;
  width: 58px;
  height: 58px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e7e7e7;
  overflow: hidden;
}
.detailsGuideMod .info .returns img {
  width: 30px;
  height: 30px;
  fill: grey;
}
.fade-enter-active, .fade-leave-active {
  /* opacity 透明度 */
  transition: opacity 1s
}
/* .fade-leave-active, 2.1.8 版本以下 */
.fade-enter, .fade-leave-to  {
  opacity: 0
}



</style>